import { resourceAccommodationZodObject } from "@@/shared/acquire/resources/resource-accommodation/resource-accommodation";
import { resourceFoundationIdZodSchema } from "@@/shared/acquire/resources/resource-foundation-id";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const resourceAccommodationEditCommandResponseZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("RESOURCE_ACCOMMODATION_EDIT_COMMAND_RESPONSE"),
    _createdAt: isoAndUnixZodSchema,

    resource: z
        .object({
            type: z.literal("FOUNDATION"),
            foundationId: resourceFoundationIdZodSchema,
            data: resourceAccommodationZodObject.omit({ _id: true }),
        })
        .or(
            z.object({
                type: z.literal("RESOURCE"),
                data: resourceAccommodationZodObject,
            }),
        ),
});

type ResourceAccommodationEditCommandResponse = z.infer<
    typeof resourceAccommodationEditCommandResponseZodObject
>;

const resourceAccommodationEditCommandResponseFactoryParamsZodObject =
    resourceAccommodationEditCommandResponseZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });
type FactoryParams = z.infer<
    typeof resourceAccommodationEditCommandResponseFactoryParamsZodObject
>;

const resourceAccommodationEditCommandResponseFactory = (
    params: FactoryParams,
) => {
    const resourceAccommodationEditCommandResponse: ResourceAccommodationEditCommandResponse =
        {
            ...params,
            _id: generateId({
                prefix: "resource_accommodation_edit_command__",
            }),
            _type: "RESOURCE_ACCOMMODATION_EDIT_COMMAND_RESPONSE",
            _createdAt: nowIsoAndUnix(),
        };
    return resourceAccommodationEditCommandResponse;
};

export {
    resourceAccommodationEditCommandResponseFactory,
    resourceAccommodationEditCommandResponseFactoryParamsZodObject,
    resourceAccommodationEditCommandResponseZodObject,
};
export type {
    ResourceAccommodationEditCommandResponse,
    FactoryParams as ResourceAccommodationEditCommandResponseFactoryParams,
};
